import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const from = location.state?.from || "/home";

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast("email + password required");
      return;
    }
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      toast("logged in");
      navigate(from, { replace: true });
    } catch (err) {
      toast(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main
      data-testid="login-page"
      className="min-h-screen bg-black text-white flex flex-col"
    >
      <header className="px-5 pt-6 pb-4 flex items-center justify-between">
        <Link
          to="/"
          className="font-mono text-sm tracking-[0.2em] uppercase text-white hover:text-acid"
        >
          <span className="text-acid">/</span> the lobby
        </Link>
        <Link
          to="/signup"
          data-testid="login-to-signup"
          className="font-mono text-[11px] uppercase tracking-wider text-white/60 hover:text-acid"
        >
          new here?
        </Link>
      </header>

      <section className="flex-1 px-5 pt-12 pb-16">
        <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-acid mb-4">
          ↓ welcome back
        </div>
        <h1 className="font-display text-5xl sm:text-6xl leading-[0.9] tracking-tight">
          log<span className="text-acid">.</span>
          <br />
          in.
        </h1>

        <form onSubmit={submit} data-testid="login-form" className="mt-10 space-y-5">
          <div>
            <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/50">
              email
            </label>
            <input
              data-testid="login-email"
              type="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@theatre.com"
              className="mt-1 w-full bg-transparent border-b-2 border-white/30 px-1 py-2.5 font-mono text-base placeholder:text-white/20 focus:border-acid outline-none"
            />
          </div>
          <div>
            <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/50">
              password
            </label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="mt-1 w-full bg-transparent border-b-2 border-white/30 px-1 py-2.5 font-mono text-base placeholder:text-white/20 focus:border-acid outline-none"
            />
          </div>
          <button
            type="submit"
            data-testid="login-submit"
            disabled={submitting}
            className="w-full mt-4 bg-acid text-black font-mono text-sm uppercase tracking-wider py-4 border-2 border-acid hover:bg-black hover:text-acid transition-colors disabled:opacity-50"
          >
            {submitting ? "logging in..." : "log in"}
          </button>
        </form>

        <div className="mt-8 font-mono text-[11px] text-white/50">
          new tester?{" "}
          <Link to="/signup" className="text-acid underline underline-offset-4">
            sign up with your invite code
          </Link>
        </div>
      </section>
    </main>
  );
}
